export const REFRESH_TOKEN_COOKIE_NAME = "refresh_token";
export const REFRESH_TOKEN_EXPIRATION_MS = 8 * 60 * 60 * 1000; // 8 hours
export const ACCESS_TOKEN_EXPIRATION_MS = 2 * 60 * 60 * 1000; // 2 hours
export const ACCESS_TOKEN_REFRESH_INTERVAL_MS = 20 * 60 * 1000; // 20 minutes
export const ACCESS_TOKEN_REFRESH_BACKOFF_MS = 15 * 60 * 1000; // 15 minutes
